
import Vue from "vue";
import { useUserStore } from "@/plugins/pinia";
import { mapStores } from "pinia";
import { Session } from "@/features/Authentication/SessionService";

export default Vue.extend({
    name: "AppBar",
    data: () => ({
        items: [
            {
                displayName: "Version 1.0.0",
                onClick: () => null,
                disabled: true,
            },
            {
                displayName: "Logout",
                onClick: function () {
                    Vue.prototype.$sessionService.logout();
                },
                disabled: false,
            },
        ],
        isNavMenuClosed: false,
    }),
    methods: {
        toggleNavMenu() {
            this.isNavMenuClosed = !this.isNavMenuClosed;
        },
    },
    computed: {
        ...mapStores(useUserStore),
        currentUser(): Session | undefined | null {
            if (this.userStore.loggedIn) {
                return this.userStore.getUser();
            }
            return null;
        },
        currentUserName(): string {
            if (this.currentUser && "name" in this.currentUser) {
                return this.currentUser.name;
            } else {
                return "";
            }
        },
    },
});
